import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  OnChanges,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import _ from 'lodash';
import { AutocompletesearchComponent } from '../component/autocomplete/auto-complete.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { NgClass, NgStyle } from '@angular/common';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { Sort } from '../pipes/sort.pipe';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-table-search',
    templateUrl: './table-search.component.html',
    styleUrls: ['./table-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatSelect, MatOption, NgClass, NgbPopover, MatRadioGroup, ReactiveFormsModule, FormsModule, MatRadioButton, NgStyle, AutocompletesearchComponent, MatButton, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatCheckbox, TranslateModule, Sort, MatFormField, MatLabel, MatInput, MatSuffix, MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatIcon, MatSlideToggle]
})
export class TableSearchComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() searchdataInput: any = [];
  @Input() innerfilterArray: any;
  @Input() multipleData = true;
  @Input() searchoptionalParams: any = [];
  @Input() filterId: any = [];
  @Input() checkOnlineStatusforClick = true;
  @Input() itemLength = 0;
  @Input() originalTableData = 0;
  @Output() returnData: EventEmitter<any> = new EventEmitter();
  @Output() clearSearch: EventEmitter<any> = new EventEmitter();
  @Output() filterSearch: EventEmitter<any> = new EventEmitter();
  @Output() clearsearchData: EventEmitter<any> = new EventEmitter();
  @Output() sortValue: EventEmitter<any> = new EventEmitter();
  @Output() sortedData: EventEmitter<any> = new EventEmitter();
  @Output() openFilterCheckStatus: EventEmitter<any> = new EventEmitter();
  @Output() openSortCheckStatus: EventEmitter<any> = new EventEmitter();
  @Output() emitOffineforAutocompleteSearch: EventEmitter<any> = new EventEmitter();
  @Output() callFocusOut: EventEmitter<any> = new EventEmitter();
  @Output() callFocusIn: EventEmitter<any> = new EventEmitter();
  @Output() apiSearchOption: EventEmitter<any> = new EventEmitter();
  @Output() sortChangeEmit: EventEmitter<any> = new EventEmitter();
  clearInput = true;
  panelOpenState = false;
  checked = false;
  disableFilterButton = true;
  disableClearAll = true;

  // Listener that stops mousedown from bubbling out of the CDK overlay container while
  // a datepicker calendar is open, preventing ng-bootstrap's document-level 'outside'
  // autoClose from dismissing the filter popover.
  private _cdkMousedownHandler: ((e: Event) => void) | null = null;

  popoverClass: string;
  common: any;
  disableIcon = true;
  searchapplied = false;
  @Input() showSort = true;
  @Input() showFilterIcon = true;
  @ViewChild('sortIcon') sortIcon: ElementRef;
  @ViewChild('filterIcon') filterIcon: ElementRef;
  @ViewChild(AutocompletesearchComponent) searchComponent: AutocompletesearchComponent;

  @Input() sortData: any = [];
  @Input() sortByOptions = [];
  @Input() defaultSort: string;

  ViewByOptions = [
    {id: 1, viewValue: 'All'},
    {id: 2, viewValue: 'Date'},
    {id: 3, viewValue: 'ID'}
  ];
  labelData: any = [];
  previousfilterArray: any;
  previousfiltervalue: any = [];
  alignFiltersId = ['newRequisition', 'newTransfers', 'newPurchase', 'createSpoilage'];
  isSearch: boolean;
  constructor(public _CommonService: CommonService, private _overlayContainer: OverlayContainer) {
    this.multipleData = this.multipleData !== undefined ? this.multipleData : true;
    this._overlayContainer.getContainerElement().classList.add('filter-overlay-container');
  }

  receivedData(event) {
      this.isSearch = true;
      this.returnData.emit(event);
  }
  ApiSearchData(event) {
    this.isSearch = true;
    this.apiSearchOption.emit(event);
  }
  clearSearchValue() {
    this.searchComponent.clearText();
  }
  clearAutoSearch() {
     this.clearSearch.emit('event');
  }

  searchApplied(event) {
    this.searchapplied = event;
    console.log(this.searchapplied);
  }

  ngAfterViewInit() {
    if (this.innerfilterArray) {
      this.previousfilterArray = JSON.parse(JSON.stringify(this.innerfilterArray));
    }

  }

  /**
   * @function selectFilter()
   * @params obj
   * @description search select return data
   * @output Array
   * **/
  selectFilter(e, i, d) {
    if (this.innerfilterArray.every(element => element.hasOwnProperty('innervalue'))) {
      this.disableApplyButton();
      this.disableClearAll = !(this.innerfilterArray?.some(
        ele => (ele.innervalue && ele.innervalue?.some(x => x.checked === true)) ||
               (ele.filterType === 'daterange' && ele.fromDate != null)));
    } else {
      if ( this.previousfiltervalue.length > 0) {
      this.disableFilterButton = !(_.differenceWith(this.previousfiltervalue, this.innerfilterArray, _.isEqual).length > 0);
      } else {
        this.disableFilterButton = !this.innerfilterArray.some(x => x.checked === true);
      }
      this.disableClearAll = !this.innerfilterArray.some(x => x.checked === true);
    }
  }

  applyFilter() {
    this.isSearch = false;
    this.clearInput = false;
    this.previousfilterArray = JSON.parse(JSON.stringify(this.innerfilterArray));
    const filterIcon: HTMLElement = this.filterIcon.nativeElement as HTMLElement ;
    filterIcon.click();
    this.disableFilterButton = true;
    // this.previousfiltervalue = [];
    /*Added as fix for 13354:[Message][Android app][J7]Apply icon is not getting enabled on unchecking the already checked option*/
    this.previousfiltervalue = JSON.parse(JSON.stringify(this.innerfilterArray));
    /******/
    this.filterSearch.emit(this.innerfilterArray);

  }

   /**
   * @function clearData()
   * @params obj
   * @description search select return data
   * @output Array
   * **/
  datePickerOpened() {
    // Attach a mousedown stopPropagation guard on the CDK overlay container.
    // ng-bootstrap's autoClose='outside' listens to document mousedown; stopping propagation
    // here means it never sees clicks on the datepicker calendar, so the filter stays open.
    if (!this._cdkMousedownHandler) {
      this._cdkMousedownHandler = (e: Event) => e.stopPropagation();
      const cdkContainer = document.querySelector('.cdk-overlay-container');
      if (cdkContainer) {
        cdkContainer.addEventListener('mousedown', this._cdkMousedownHandler, false);
      }
    }
    // After CDK positions the panel, push it upward if it overflows the viewport.
    setTimeout(() => this._adjustDatePickerPosition(), 0);
  }

  datePickerClosed() {
    // Wait for any pending mouseup to be processed before removing the guard.
    setTimeout(() => this._removeCdkMousedownHandler(), 200);
  }

  private _removeCdkMousedownHandler() {
    if (this._cdkMousedownHandler) {
      const cdkContainer = document.querySelector('.cdk-overlay-container');
      if (cdkContainer) {
        cdkContainer.removeEventListener('mousedown', this._cdkMousedownHandler, false);
      }
      this._cdkMousedownHandler = null;
    }
  }

  private _adjustDatePickerPosition() {
    const panel = document.querySelector('.cdk-overlay-pane.filter-datepicker-panel') as HTMLElement;
    if (!panel) { return; }
    const rect = panel.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const overflow = rect.bottom - viewportHeight;
    if (overflow > 0) {
      // Move the panel upward by the overflow amount plus an 8 px safety gap.
      const currentTop = parseFloat(panel.style.top || '0');
      panel.style.top = `${Math.max(8, currentTop - overflow - 8)}px`;
    }
  }

  /** True when any filter option is checked — keeps filter/search enabled for 0–1 row results. */
  hasCheckedFilter(): boolean {
    return Array.isArray(this.innerfilterArray)
      && this.innerfilterArray.some((ele: any) =>
        ele?.innervalue?.some((x: any) => x?.checked === true)
        || (ele?.filterType === 'daterange' && ele?.fromDate != null));
  }

  onDateRangeChange(filterList: any) {
    this.disableClearAll = !(this.innerfilterArray.some(
      ele => (ele.innervalue && ele.innervalue.some(x => x.checked === true)) ||
             (ele.filterType === 'daterange' && ele.fromDate != null)));
    this.disableApplyButton();
  }

  clearData() {
    this.disableFilterButton = false;
    this.disableClearAll = true;
    if (this.innerfilterArray.every(element => element.hasOwnProperty('innervalue'))) {
      this.innerfilterArray.forEach(element => {
        if (element.filterType === 'daterange') {
          element.fromDate = null;
          element.toDate = null;
        }
        element.innervalue.forEach(item => {
          item.checked = false;
        });
      });
    } else {
      this.innerfilterArray.forEach(element => {
        element.checked = false;
      });
    }
    this.disableApplyButton();
    this.filterSearch.emit(this.innerfilterArray);
  }

  disableApplyButton() {
    if ( this.previousfiltervalue.length > 0) {
      let disableApply = true;
      this.innerfilterArray.forEach(element => {
        let previousIndex = -1;
        if (element.jsonKey) {
          previousIndex = this.previousfiltervalue.findIndex(x => x.jsonKey === element.jsonKey);
        } else {
          previousIndex = this.previousfiltervalue.findIndex(x => x.id === element.id);
        }
        if (this.previousfiltervalue[previousIndex].innervalue) {
          if (_.differenceWith(this.previousfiltervalue[previousIndex].innervalue, element.innervalue , _.isEqual).length > 0) {
            disableApply = false;
          }
          if (element.filterType === 'daterange' &&
            (this.previousfiltervalue[previousIndex].fromDate !== element.fromDate ||
             this.previousfiltervalue[previousIndex].toDate !== element.toDate)) {
            disableApply = false;
          }
        } else {
          if (!(_.isEqual(this.previousfiltervalue[previousIndex], element))) {
            disableApply = false;
          }
        }
      });
      this.disableFilterButton = disableApply;
    } else {
      this.disableFilterButton = !(this.innerfilterArray.some(
        ele => (ele.innervalue && ele.innervalue.some(x => x.checked === true)) ||
               (ele.filterType === 'daterange' && ele.fromDate != null)));
    }
  }
  ngOnInit() {
    this.popoverClass = `${this.filterId} filter-popover`;
    this.defaultSort = this._CommonService.defaultSort;
    if (this.innerfilterArray) {
      this.previousfilterArray = JSON.parse(JSON.stringify(this.innerfilterArray));

      if (this.innerfilterArray.every(element => element.hasOwnProperty('innervalue'))) {
        this.disableClearAll = !(this.innerfilterArray.some(
          ele => (ele.innervalue && ele.innervalue.some(x => x.checked === true)) ||
                 (ele.filterType === 'daterange' && ele.fromDate != null)));
      } else {
        this.disableClearAll = !this.innerfilterArray.some(x => x.checked === true);
      }
    }
  }

  sortChange(value: string, isclicked?: boolean) {
    this.isSearch = false;
    const data = this.sortData;
    const selectedOption = this.sortByOptions?.find(x => x.viewValue === value);
    if (!selectedOption) return data;
    
    const { sort: key, id: order, type, viewValue } = selectedOption;
    const list = {
      key: viewValue.split('-')[0].trim(),
      order: order === "aesc" ? "asc" : "desc"
    };
    
    if (isclicked) {
      this.sortChangeEmit.emit(list);
    }
  
    this.sortByOptions.forEach(element => (element.checked = false));
    this.sortByOptions.find(item => item.viewValue === value).checked = true;
    
    if (!key || data?.length === 0) return data;
    
    data?.sort((a, b) => {
      if (type === 'number') {
        const valA = Number(a[key] ?? 0);
        const valB = Number(b[key] ?? 0);
        return order === 'desc' ? valB - valA : valA - valB;
      }
      const valA = (a[key] ?? '').toString().replace(/\s/g, '').toLowerCase();
      const valB = (b[key] ?? '').toString().replace(/\s/g, '').toLowerCase();
      
      if (order === 'desc') return valA < valB ? 1 : -1;
      return valA > valB ? 1 : -1;
    });
  
    if (isclicked && this.sortIcon) {
      (this.sortIcon.nativeElement as HTMLElement).click();
    }
  
    this.sortValue.emit([order, key, type]);
  }
  

  accordianOpen(event) {
    let index = 0;
    if (event.id !== 1) {
      index = event.id - 2;
    }
    const popOverBody = document.getElementsByClassName('popover-content-body')[0],
    panelContent = document.getElementsByClassName('mat-expanded')[0];
    if (document.getElementsByClassName('mat-expansion-panel-header')[index]) {
      const prevEleBottom = document.getElementsByClassName('mat-expansion-panel-header')[index]['offsetTop'];
      panelContent.scrollIntoView(({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
      if (popOverBody.clientHeight < panelContent.clientHeight) {
        popOverBody.scroll({ top: prevEleBottom , left: 0, behavior: 'smooth' });
      }
    }
    this.calcFilterPosition();
  }

  ngOnChanges(changes) {
      if (this.sortByOptions) {
        if (this.sortByOptions.find(x => x.checked === true)) {
          this.defaultSort = this.sortByOptions.find(x => x.checked === true).viewValue;
        } else {
          this.defaultSort = this._CommonService.defaultSort;
        }
      }
      if(changes?.itemLength?.firstChange && this.itemLength == 0){
        this.disableIcon = true;
      }
      else{
        this.disableIcon = false;
      }

     if (this.defaultSort && !this.isSearch && (changes.hasOwnProperty('itemLength') && changes?.itemLength?.firstChange)) {
        this.sortChange(this.defaultSort, false);
      }
      if (this.innerfilterArray) {
        this.previousfiltervalue = JSON.parse(JSON.stringify(this.innerfilterArray));
      }
      if(this.innerfilterArray?.length){
        this.disableIcon = !this.innerfilterArray?.some(x => x.innervalue?.length > 0);
      }
  }

  openFilter() {
    if (this.checkOnlineStatusforClick !== false) {
      this._CommonService.bodyContainer.nativeElement.classList.add('blur');
      this._CommonService.filterOverlay.nativeElement.classList.add('d-block');

    }
     this.openFilterCheckStatus.emit(event);

  }
  closeFilter() {
    /*if filter not applied, store pervious filter value and disable clear all button on filter popover close action*/
    if (this.clearInput) {
      this.innerfilterArray = JSON.parse(JSON.stringify(this.previousfiltervalue));
      if (this.previousfiltervalue) {
        if (this.previousfiltervalue.every(element => element.hasOwnProperty('innervalue'))) {
          this.disableClearAll = !(this.previousfiltervalue.filter(
            ele => ele.innervalue && ele.innervalue.some(x => x.checked === true)).length > 0);
        } else {
          this.disableClearAll = !this.previousfiltervalue.some(x => x.checked === true);
        }
      }
    }
    this.disableApplyButton();
    this.clearInput = true;
    this._CommonService.bodyContainer.nativeElement.classList.remove('blur');
    this._CommonService.filterOverlay.nativeElement.classList.remove('d-block');
    // Safety net: ensure CDK mousedown guard is removed if filter closes unexpectedly.
    this._removeCdkMousedownHandler();
  }
  showFilter() {
    const searchBarTop = document.getElementsByClassName('search-bar')[0].getBoundingClientRect().top;
    const that = this;
    setTimeout(function() {
      if (searchBarTop < 120) {
        if (that.filterId === 'poloadRequisition') {
          document.getElementsByClassName('filter-popover')[0].classList.add('poLoadReqcustom-top');
        } else if (that.filterId === 'savedrequisition') {
          document.getElementsByClassName('filter-popover')[0].classList.add('savedReqcustom-top');
        } else if (that.filterId !== 'newRequisition' && that.filterId !== 'newTransfers' &&
        that.filterId !== 'newPurchase' && that.filterId !== 'createSpoilage' ) {
          document.getElementsByClassName('filter-popover')[0].classList.add('custom-top');
        } else {
          that.calcFilterPosition();
        }
      } else {
        document.getElementsByClassName('filter-popover')[0].classList.remove('custom-top');
      }
     }, 1);

  }
  openSort() {
    this.openSortCheckStatus.emit(event);
  }

  emitOffineNoDataforAutocompleteSearch() {
    this.emitOffineforAutocompleteSearch.emit();
  }

  autocompleteFO() {
    this.callFocusOut.emit();
  }

  autocompleteFI() {
    this.callFocusIn.emit();
  }

calcFilterPosition() {
  const filterPopover = document.getElementsByClassName('filter-popover') as HTMLCollectionOf<HTMLElement>;
  const filterpopoverpostionset = filterPopover[0].classList.value.split(' ').filter(checkId => {
      const alignfilter  = this.alignFiltersId.filter(alignFilterId => {
          if (checkId === alignFilterId) {
            setTimeout(() => {
              const filterPopOverHTML = document.getElementsByClassName(checkId + ' filter-popover') as HTMLCollectionOf<HTMLElement>;
              const customFilterIconHTML
               = document.getElementsByClassName('icon-filter custom-filter-icon') as HTMLCollectionOf<HTMLElement>;
              const checkFiltertopPx = filterPopOverHTML[0].offsetTop;
                if (checkFiltertopPx < 0) {
                  const setArrowTop = customFilterIconHTML[0].getBoundingClientRect().top + 5;
                  const arrowHTML = filterPopOverHTML[0].getElementsByClassName('arrow') as HTMLCollectionOf<HTMLElement>;
                  arrowHTML[0].style.top = setArrowTop + 'px';
                  filterPopOverHTML[0].classList.add('topZero');
              }
            }, 0);
          }
        });
        console.log(alignfilter);
    });
    console.log(filterpopoverpostionset);
}

ngOnDestroy(): void {
}


}
